export default __webpack_public_path__ + "static/left-side-white-bundle-page-f24a5717ed433c32580b491ee9eefcbf.png";